export type AchievementsHandler = {
  init: () => Promise<boolean>;
  unlockAchievement: (name: string, delay?: number, store?: boolean) => Promise<boolean>;
  getAchievement: (name: string) => Promise<boolean>;
  clearAchievement: (name: string, store?: boolean) => Promise<boolean>;
  storeStats: () => Promise<boolean>;
  setStatInt: (name: string, value: number, store?: boolean) => Promise<boolean>;
  getStatInt: (name: string) => Promise<number>;
  incrementStatInt: (name: string, amount: number, store?: boolean) => Promise<boolean>;
  setStatFloat: (name: string, value: number, store?: boolean) => Promise<boolean>;
  getStatFloat: (name: string) => Promise<number>;
  incrementStatFloat: (name: string, amount: number, store?: boolean) => Promise<boolean>;
};

export const AchievementsHandler = (): AchievementsHandler => {
  let instance: AchievementsHandler | null = (window as any).achievements_handler || null;

  let isInitialized = false;

  if (instance) {
    return instance;
  }

  const steam = () => window.gemshell?.steam;

  const init = async (): Promise<boolean> => {
    if (isInitialized) return true;
    isInitialized = (await steam()?.init()) ?? false;

    return isInitialized;
  };

  const storeStats = async (): Promise<boolean> => {
    return (await steam()?.storeStats()) ?? false;
  };

  const unlockAchievement = async (name: string, delay?: number, store = true): Promise<boolean> => {
    if (delay) {
      await new Promise(resolve => setTimeout(resolve, delay));
    }

    const result = (await steam()?.unlockAchievement(name)) ?? false;
    if (store) await storeStats();
    return result;
  };

  const getAchievement = async (name: string): Promise<boolean> => {
    const result = (await steam()?.getAchievement(name)) ?? false;

    return result
  };

  const clearAchievement = async (name: string, store = true): Promise<boolean> => {
    const result = (await steam()?.clearAchievement(name)) ?? false;
    if (store) await storeStats();
    return result;
  };

  const setStatInt = async (name: string, value: number, store = true): Promise<boolean> => {
    const result = (await steam()?.setStatInt(name, value)) ?? false;
    if (store) await storeStats();
    return result;
  };

  const getStatInt = async (name: string): Promise<number> => {
    // const state = await steam()?.getStatsState();
    // alert(`stats state: ${state}`);

    const result = (await steam()?.getStatInt(name)) ?? 0;
    // alert(`Stat ${name} is ${result}`);


    return result;
  };

  const setStatFloat = async (name: string, value: number, store = true): Promise<boolean> => {
    const result = (await steam()?.setStatFloat(name, value)) ?? false;
    if (store) await storeStats();
    return result;
  };

  const getStatFloat = async (name: string): Promise<number> => {
    return (await steam()?.getStatFloat(name)) ?? 0;
  };

  // const incrementStatInt = async (name: string, amount: number, store = true): Promise<boolean> => {
  //   const current = (await steam()?.getStatInt(name)) ?? 0;
  //   const result = (await steam()?.setStatInt(name, current + amount)) ?? false;
  //   if (store) await storeStats();
  //   // alert(`Incremented stat ${name} by ${amount} to ${current + amount}`);
  //   return result;
  // };

  const incrementStatInt = async (name: string, amount: number, store = true): Promise<boolean> => {
    if (!await steam()?.areStatsReady() && !await steam()?.requestStatsAndWait(3000)) {
      console.warn('Stats not ready yet, and failed to request stats');
      return false;
    }

    const current = (await steam()?.getStatInt(name)) ?? 0;
    const result = (await steam()?.setStatInt(name, current + amount)) ?? false;

    console.log(`Incremented stat ${name} by ${amount} to ${current + amount}`);
    if (store) await storeStats();
    return result;
  };

  const incrementStatFloat = async (name: string, amount: number, store = true): Promise<boolean> => {
    const current = (await steam()?.getStatFloat(name)) ?? 0;
    const result = (await steam()?.setStatFloat(name, current + amount)) ?? false;
    if (store) await storeStats();
    return result;
  };

  instance = {
    init,
    unlockAchievement,
    getAchievement,
    clearAchievement,
    storeStats,
    setStatInt,
    getStatInt,
    incrementStatInt,
    setStatFloat,
    getStatFloat,
    incrementStatFloat,
  };

  (window as any).achievements_handler = instance;

  return instance;
};
